const ObservationsDisableSubmitButton = (options = {}) => {
  const _defaults = {
    formSelector: 'observations-edit-form',
    submitButtonSelector: 'observations-edit-submit',
    fieldSelector: 'input, select, textarea',
  };

  const _settings = { ..._defaults, ...options };

  let form, submitButton, fields;
  let initialValues = {};

  const checkForChanges = () => {
    let changed = false;

    Object.keys(initialValues).forEach((name) => {
      const fieldGroup = form.elements[name];
      let currentValue = fieldGroup.value;

      if (currentValue !== initialValues[name]) {
        changed = true;
      }
    });

    submitButton.disabled = !changed;
  };

  // Public: Initialise module
  const init = () => {
    form = document.getElementById(_settings.formSelector);
    if (!form) return;

    submitButton = form.querySelector(`#${_settings.submitButtonSelector}`);
    fields = form.querySelectorAll(_settings.fieldSelector);

    fields.forEach((field) => {
      // For radios buttons, only store the checked one
      if (field.name && (field.type !== 'radio' || field.checked)) {
        initialValues[field.name] = field.value;
      }

      ['input', 'change'].forEach((evt) =>
        field.addEventListener(evt, checkForChanges)
      );
    });

    checkForChanges();
  };

  // Public: Destroy module instance
  const destroy = () => {
    if (!fields) return;
    fields.forEach((field) => {
      field.removeEventListener('input', checkForChanges);
      field.removeEventListener('change', checkForChanges);
    });
  };

  // Public: Destroy module instance and run initialise again
  const reinit = () => {
    destroy();
    initialValues = {};
    init();
  };

  return {
    init,
    destroy,
    reinit,
  };
};

export default ObservationsDisableSubmitButton;
